import React, { useState, useEffect } from 'react';
import { FaBook, FaPlay } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { fetchAPI } from '../../utils/api';
import { useNavigate } from 'react-router-dom';

export default function ContinueWatching() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [unlocked, setUnlocked] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadUnlocked = async () => {
            if (!currentUser) return;
            try {
                const data = await fetchAPI(`/student/get_unlocked_content.php?user_id=${currentUser.id}`);
                setUnlocked(data);
            } catch (err) {
                console.error("Failed to load unlocked content", err);
            } finally {
                setLoading(false);
            }
        };
        loadUnlocked();
    }, [currentUser]);

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-blue-50/50 p-6 relative overflow-hidden group hover:shadow-md transition-all duration-300">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50/50 rounded-full blur-2xl -mr-10 -mt-10 transition-transform group-hover:scale-110"></div>

            <div className="flex items-center justify-between mb-6 relative z-10">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
                        <FaBook size={14} />
                    </div>
                    <h2 className="text-lg font-bold text-gray-900">Continue Learning</h2>
                </div>
                <button
                    onClick={() => navigate('/dashboard/courses')}
                    className="text-xs font-bold text-blue-600 hover:text-blue-700 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-full transition-colors"
                >
                    Browse All
                </button>
            </div>

            <div className="space-y-4 relative z-10">
                {loading ? (
                    <div className="space-y-3">
                        <div className="h-12 bg-gray-50 animate-pulse rounded-xl"></div>
                        <div className="h-12 bg-gray-50 animate-pulse rounded-xl"></div>
                    </div>
                ) : unlocked.length === 0 ? (
                    <div className="py-6 text-center">
                        <p className="text-gray-400 text-sm font-medium">No unlocked courses yet.</p>
                        <button
                            onClick={() => navigate('/dashboard/courses')}
                            className="text-blue-600 text-[10px] font-black uppercase mt-2 hover:underline"
                        >
                            Get Started Now
                        </button>
                    </div>
                ) : (
                    unlocked.slice(0, 3).map((item, idx) => (
                        <div
                            key={idx}
                            className="group/item flex items-center justify-between p-3 rounded-xl hover:bg-blue-50 transition-all cursor-pointer border border-transparent hover:border-blue-100"
                            onClick={() => navigate(`/dashboard/courses/class/${item.class_id}/lesson/${item.month_id}`)}
                        >
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-blue-600/10 text-blue-600 rounded-lg flex items-center justify-center group-hover/item:bg-blue-600 group-hover/item:text-white transition-all">
                                    <FaPlay size={12} className="ml-0.5" />
                                </div>
                                <div className="overflow-hidden">
                                    <h4 className="text-sm font-bold text-gray-800 truncate">{item.month_name}</h4>
                                    <p className="text-[10px] text-gray-400 font-bold uppercase truncate">{item.class_name}</p>
                                </div>
                            </div>
                            <div className="text-right flex-shrink-0">
                                <span className="text-[9px] font-black text-gray-400 uppercase tracking-tighter">{item.lessons_count} Lessons</span>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
